/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.progress', [])
  /**
   * Service used to access all calls to the progress rest service.
   */
  .factory('httpProgress', function ($http) {
    /**
     * Get the current progress objects for the org.
     *
     * @returns {Response|Error} An http response object on success, an Error on failure.
     */
    var getProgress = function () {
      return $http({
        method: 'GET',
        url: 'api/progress'
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getProgress: getProgress
    };
  });
